import styled from 'styled-components';

export const SmallerModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1,
  h2,
  h4,
  h5 {
    margin: 0.5vw;
  }

  h3 {
    margin: 1.5vw 0 0.5vw 0;
  }
  h4 {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 3vw 0;
  width: 28.572vw;
`;

export const ContainerMensagem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SeparatorInput = styled.div`
  margin: 0.6vw 0 0 0;
`;
